module.exports = __webpack_public_path__ + "img/blue_050.5954460b.png";